import { APP_URL } from "../Constants/constants";

// Repassados ao app para ele registrar em metadata.campanha no checkout.
const CAMPAIGN_PARAMS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "campanha",
];

/**
 * Monta uma URL do app. `params` vem primeiro; parâmetros de campanha
 * presentes em `search` (a query string da landing) são anexados em seguida.
 */
export const buildAppUrl = (path = "", { params = {}, search = "" } = {}) => {
  const query = new URLSearchParams(params);
  const incoming = new URLSearchParams(search);

  CAMPAIGN_PARAMS.forEach((key) => {
    const value = incoming.get(key);
    if (value && !query.has(key)) query.set(key, value);
  });

  const queryString = query.toString();
  return `${APP_URL}${path}${queryString ? `?${queryString}` : ""}`;
};
